import baseTheme from '@sportnet/ui/lib/Themes/baseTheme';

export default baseTheme;
